module.exports = __webpack_public_path__ + "static/media/intro.4e3fb930.mp3";